import { render, staticRenderFns } from "./I18n.vue?vue&type=template&id=e24e5244&scoped=true&"
import script from "./I18n.vue?vue&type=script&lang=js&"
export * from "./I18n.vue?vue&type=script&lang=js&"
import style0 from "./I18n.vue?vue&type=style&index=0&id=e24e5244&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e24e5244",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e24e5244')) {
      api.createRecord('e24e5244', component.options)
    } else {
      api.reload('e24e5244', component.options)
    }
    module.hot.accept("./I18n.vue?vue&type=template&id=e24e5244&scoped=true&", function () {
      api.rerender('e24e5244', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/I18n.vue"
export default component.exports